/**
 * Matomo Analytics - chargement du script et tracking SPA
 * Variables requises : REACT_APP_MATOMO_URL, REACT_APP_MATOMO_SITE_ID
 */

const MATOMO_URL = process.env.REACT_APP_MATOMO_URL?.replace(/\/$/, '');
const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;

export const isMatomoEnabled = () => Boolean(MATOMO_URL && MATOMO_SITE_ID);

let matomoInitialized = false;

const isMatomoScriptLoaded = () =>
  Array.from(document.querySelectorAll('script')).some(
    (s) => s.src && s.src.includes('/matomo.js')
  );

export const initMatomo = () => {
  if (!isMatomoEnabled() || matomoInitialized) return;
  matomoInitialized = true;

  window._paq = window._paq || [];
  if (!isMatomoScriptLoaded()) {
    window._paq.push(['setTrackerUrl', `${MATOMO_URL}/matomo.php`]);
    window._paq.push(['setSiteId', MATOMO_SITE_ID]);
    window._paq.push(['enableLinkTracking']);

    const script = document.createElement('script');
    script.async = true;
    script.src = `${MATOMO_URL}/matomo.js`;
    document.head.appendChild(script);
  }
};

export const trackPageView = (customUrl) => {
  if (!isMatomoEnabled() || !window._paq) return;

  if (customUrl) {
    window._paq.push(['setCustomUrl', customUrl]);
  }
  window._paq.push(['trackPageView']);
};

export const trackEvent = (category, action, name) => {
  if (!isMatomoEnabled() || !window._paq) return;
  window._paq.push(['trackEvent', category, action, name]);
};
